import React from "react";
import { motion } from "framer-motion";
import { Stage, useStageMotion } from "@/components/Stage";
import { Eyebrow } from "@/components/Wordmark";

export const CoverSlide = ({ data }) => {
  const { container, item } = useStageMotion();
  const c = data?.cover || {};

  return (
    <Stage testId="slide-cover">
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="h-full w-full flex flex-col justify-center px-[clamp(32px,9%,120px)] py-[clamp(36px,8%,80px)]"
      >
        <motion.div variants={item} className="mb-7">
          <Eyebrow>{c.eyebrow}</Eyebrow>
        </motion.div>

        <motion.h1
          variants={item}
          className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ink max-w-4xl"
        >
          {c.titleLead}{" "}
          <span className="text-accent">{c.titleAccent}</span>
        </motion.h1>

        <motion.p
          variants={item}
          className="mt-6 text-base sm:text-lg text-ink-soft leading-relaxed max-w-2xl"
        >
          {c.subtitle}
        </motion.p>

        <motion.div
          variants={item}
          className="mt-10 flex items-center gap-4"
        >
          <span className="w-[3px] self-stretch bg-accent rounded-full" />
          <div>
            <p className="font-sans text-sm font-medium text-ink">{c.stat}</p>
            <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-muted mt-1">
              {c.statCaption}
            </p>
          </div>
        </motion.div>

        <motion.p
          variants={item}
          className="mt-12 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-muted"
        >
          {c.hint}
        </motion.p>
      </motion.div>
    </Stage>
  );
};

export default CoverSlide;
